<nav aria-label="breadcrumb" class="nav-breadcrumbs">
  <ol class="breadcrumb mb-0">
    <li class="breadcrumb-item">
      <a routerLink="/admin"
        ><fa-icon [icon]="faHouse"></fa-icon>
        @if (!breadcrumbLinks.length) {
          <span
            class="ms-2"
            [innerText]="'GENERAL.HOME' | translate"
            ></span
            >
          }</a>
        </li>
        @for (breadcrumbLink of breadcrumbLinks; track breadcrumbLink.url ?? $index; let i = $index) {
          <li
            class="breadcrumb-item"
            [class.active]="i === breadcrumbLinks.length - 1"
            [class.placeholder-glow]="breadcrumbLink.isPlaceholder"
            aria-current="page"
            >
            @if (breadcrumbLink.isPlaceholder) {
              <div class="placeholder"></div>
            }
            @if (i < breadcrumbLinks.length - 1) {
              <a
                [routerLink]="breadcrumbLink.url"
                [innerHtml]="breadcrumbLink.text | translate"
              ></a>
            }
            @if (i === breadcrumbLinks.length - 1) {
              <span
                [innerHtml]="breadcrumbLink.text | translate"
              ></span>
            }
          </li>
        }
      </ol>
    </nav>
